import * as React from 'react';
var EmptyWrapper = function (_a) {
    var _b;
    var children = _a.children, emptyRender = _a.emptyRender, isRefetching = _a.isRefetching;
    return !isRefetching ? React.createElement(React.Fragment, null, ((_b = React.Children.toArray(children)) === null || _b === void 0 ? void 0 : _b.length) > 0 ? children : emptyRender()) : null;
};
export default EmptyWrapper;
